<template>
  <b-nav-item-dropdown
    v-if="userData && !hideUserDropDown"
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-md-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName }}
        </p>
        <span class="user-status">{{ userData.role }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.fullName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="confirmPasswordResetLink"
    >
      <feather-icon
        size="16"
        icon="LinkIcon"
        class="mr-50"
      />
      <span>{{ $t('Reset Password') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import axios from 'axios'

import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
      hideUserDropDown: true,
    }
  },
  created() {
    this.checkHideUserDropDown()
  },
  methods: {
    async checkHideUserDropDown() {
      await useJwt.axiosIns.get('settings/HideUserDropDown')
        .then(response => {
          this.hideUserDropDown = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    confirmPasswordResetLink() {
      this.$swal({
        title: this.$t('Reset Password'),
        text: this.$t('You are about to send password reset link...'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Yes, send it!'),
        cancelButtonText: this.$t('Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.passwordResetLink()
        }
      })
    },
    passwordResetLink() {
      useJwt.axiosIns.post('user/PasswordReset', { Email: this.userData.email })
        .then(() => {
          this.$swal({
            icon: 'success',
            title: this.$t('Sent!'),
            text: this.$t('Please check your inbox for password reset link.'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
        .catch(e => {
          console.log(e.status)
        })
    },
    async externalLogout(ssoLogoutUrl) {
      if (ssoLogoutUrl) {
        return axios.post(ssoLogoutUrl, {})
          .then(() => {
          })
          .catch(error => {
            console.log(error)
          })
      }
      return true
    },
    async getSsoLogoutUrl() {
      useJwt.axiosIns.get('settings/SsoLogoutUrl')
        .then(response => {
          if (response.data) {
            const ssoLogoutUrl = response.data

            axios.post(ssoLogoutUrl, {})
              .then(() => {
                // Remove userData from localStorage
                // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
                localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
                localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

                // Remove userData from localStorage
                localStorage.removeItem('userData')

                // Reset ability
                this.$ability.update(initialAbility)

                // Redirect to loggedOut page
                setTimeout(() => {
                  this.$router.push({ name: 'loggedOut' })
                }, 2000)
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            // Remove userData from localStorage
            // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
            localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
            localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

            // Remove userData from localStorage
            localStorage.removeItem('userData')

            // Reset ability
            this.$ability.update(initialAbility)

            // Redirect to loggedOut page
            this.$router.push({ name: 'loggedOut' })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    async logout() {
      await this.getSsoLogoutUrl()
      // await this.externalLogout(ssoLogoutUrl)
    },
  },
}
</script>
